var React = require('react');

function ElectricPlug (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.1426 9.00965C14.1426 8.81659 14.1234 6.45477 14.1234 6.45477C14.1234 6.10082 13.8275 5.81123 13.4737 5.81123H12.2257V0.643547C12.2257 0.289596 11.9363 0 11.5825 0H10.9392C10.5854 0 10.296 0.289596 10.296 0.643547V5.81123H7.72292V0.643547C7.72292 0.289596 7.43345 0 7.07966 0H6.4364C6.08261 0 5.79314 0.289596 5.79314 0.643547V5.81123H4.50019C4.1464 5.81123 3.85693 6.10082 3.85693 6.45477V8.35324C3.85693 8.70719 3.85693 8.99678 3.85693 8.99678V9.00322C3.85693 9.00322 3.85693 9.00322 3.85693 9.00965C3.85693 11.6418 5.83174 13.8105 8.37905 14.1194V17.3565C8.37905 17.7104 8.66851 18 9.02231 18C9.3761 18 9.66556 17.7104 9.66556 17.3565V14.113C12.2 13.7848 14.1426 11.6289 14.1426 9.00965Z","fill":"white"}));
}

ElectricPlug.defaultProps = {"viewBox":"0 0 18 18","fill":"none"};

module.exports = ElectricPlug;

ElectricPlug.default = ElectricPlug;
